module.exports = __webpack_public_path__ + "69c0e61d1167be8b7869a39b8ab98040.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/shared/sound/loops/loop4.wav
// module id = 89
// module chunks = 0